export var SEARCH_BY = {
    name: 'Name',
    status: 'Status',
    role: 'Role',
};
export var STATUS_VALUES = {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
};
export var ROLE_VALUES = {
    admin: 'Admin',
    purchaser: 'Purchaser',
    runner: 'Runner',
};
export var SEARCH_TYPE_VALUES = {
    status: STATUS_VALUES,
    role: ROLE_VALUES,
};
